<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="剧本名称" prop="scriptName">
                <a-input v-model="queryParam.scriptName" placeholder="请输入剧本名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否可申领" prop="isApply">
                <a-select style="width: 250px" v-model="queryParam.isApply" placeholder="请设置是否可申领" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['played:script:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['played:script:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:script:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['played:script:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 店铺开本卷包配置 -->
      <store-packaging-config
        ref="storePackagingConfig"
      />
      <!-- 生成剧本编码及二维码 -->
      <export-batch-generate-script-code-form
        ref="exportBatchGenerateScriptCodeForm"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="scriptId"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="openApplyTime" slot-scope="text, record">
          {{ parseTime(record.openApplyTime) }}
        </span>
        <span slot="expectedShippingMissionDate" slot-scope="text, record">
          {{ parseTime(record.expectedShippingMissionDate) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" v-hasPermi="['played:script:notify']">
              发送新本通知 <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => onClickNewScript(e, record.scriptId)">
              <a-menu-item key="1">
                银河玩本通知
              </a-menu-item>
              <a-menu-item key="2">
                银河开本助手通知
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-divider type="vertical" v-hasPermi="['played:script:notify']"/>
          <br v-hasPermi="['played:script:notify']"/>
          <a @click="generateShopScript(record)" v-hasPermi="['played:script:edit']">
            <a-icon type="container"/> 生成店铺剧本
          </a>
          <a-divider type="vertical" v-hasPermi="['played:script:edit']" />
          <br/>
          <a @click="$refs.storePackagingConfig.handle(record)" v-hasPermi="['played:script:storePackagingConfig']" :disabled="!record.openVolumePackagePurchasable">
            <a-icon type="setting" /> 店铺开本卷包配置
          </a>
          <br/>
          <a @click="$refs.exportBatchGenerateScriptCodeForm.handle(record)" v-hasPermi="['played:script/activation:export']">
            <a-icon type="download" /> 生成剧本编码及二维码
          </a>
          <a-divider type="vertical" v-hasPermi="['played:script:storePackagingConfig']" />
          <br/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['played:script:edit']">
            <a-icon type="edit" /> 修改
          </a>
          <a-divider type="vertical" v-hasPermi="['played:script:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['played:script:remove']">
            <a-icon type="delete" /> 删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <a-modal
      ref="newProductSubscriptions"
      title="新品上线通知"
      :width="500"
      :visible="newProductSubscriptionsModal"
      class="new-product-subscriptions"
      @ok="noticeSubscriptions('1')"
      @cancel="closeModal"
    >
      <a-form-model-item label="新品介绍">
        <a-input v-model="strValue1" style="width: 100%" placeholder="请输入请阅通知的新品介绍" allow-clear />
      </a-form-model-item>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageScript, delScript, listScript } from '@/api/played/script'
import { generatePlayedScriptById } from '@/api/played/shopScript'
import { sendScriptLaunch } from '@/api/wx/miniSubscriptions'
import CreateForm from './modules/CreateForm'
import StorePackagingConfig from './modules/StorePackagingConfig'
import ExportBatchGenerateScriptCodeForm from './modules/ExportBatchGenerateScriptCodeForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Script',
  components: {
    CreateForm, StorePackagingConfig, ExportBatchGenerateScriptCodeForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      playedScriptList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      names: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        scriptId: undefined,
        scriptName: undefined,
        bannerImg: null,
        dmNum: null,
        npcNum: null,
        isAllowReverse: null,
        performanceTime: null,
        singlePersonReadVolume: null,
        customLabels: null,
        scriptPackageLabels: null,
        scriptHighlights: null,
        otherNotes: null,
        firstCityPrices: null,
        newFirstCityPrices: null,
        secondCityPrices: null,
        thirdCityPrices: null,
        fourthCityPrices: null,
        fifthCityPrices: null,
        applyWay: null,
        preOrderCarNum: null,
        firstCityOrderPrices: null,
        newFirstCityOrderPrices: null,
        secondCityOrderPrices: null,
        thirdCityOrderPrices: null,
        fourthCityOrderPrices: null,
        fifthCityOrderPrices: null,
        quickPlayedPrices: null,
        isHandselScript: null,
        openApplyTime: null,
        expectedShippingMissionDate: null,
        playedElectronicInfo: null,
        isMultipleEndings: null,
        isApply: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '剧本id',
        //   dataIndex: 'scriptId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '剧本名称',
          dataIndex: 'scriptName',
          fixed: 'left',
          ellipsis: true,
          width: 140,
          align: 'center'
        },
        {
          title: '申领方式',
          dataIndex: 'applyWay',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text) => {
            return { 1: '免费申领', 2: '预购x车' }[text]
          }
        },
        {
          title: '预购车数量',
          dataIndex: 'preOrderCarNum',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '一线价位',
          dataIndex: 'firstCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.firstCityPrices} / {record.firstCityOrderPrices}</span>
          }
        },
        {
          title: '新一线价位',
          dataIndex: 'newFirstCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.newFirstCityPrices} / {record.newFirstCityOrderPrices}</span>
          }
        },
        {
          title: '二线价位',
          dataIndex: 'secondCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.secondCityPrices} / {record.secondCityOrderPrices}</span>
          }
        },
        {
          title: '三线价位',
          dataIndex: 'thirdCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.thirdCityPrices} / {record.thirdCityOrderPrices}</span>
          }
        },
        {
          title: '四线价位',
          dataIndex: 'fourthCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.fourthCityPrices} / {record.fourthCityOrderPrices}</span>
          }
        },
        {
          title: '五线价位',
          dataIndex: 'fifthCityPrices',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text, record) => {
            return <span>{record.fifthCityPrices} / {record.fifthCityOrderPrices}</span>
          }
        },
        {
          title: '是否可申领',
          dataIndex: 'isApply',
          ellipsis: true,
          width: 100,
          align: 'center',
          customRender: (text) => {
            return { true: '是', false: '否' }[text]
          }
        },
        {
          title: '开放申领时间',
          dataIndex: 'openApplyTime',
          scopedSlots: { customRender: 'openApplyTime' },
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      newProductSubscriptionsModal: false,
      strValue1: null,
      scriptId: null
    }
  },
  filters: {
  },
  created () {
    this.getList()
    listScript({ scriptName: this.queryParam.scriptName }).then(res => {
      this.playedScriptList = res.data
    })
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本剧本列表 */
    getList () {
      this.loading = true
      pageScript(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        scriptId: undefined,
        scriptName: undefined,
        bannerImg: undefined,
        dmNum: undefined,
        npcNum: undefined,
        isAllowReverse: undefined,
        performanceTime: undefined,
        singlePersonReadVolume: undefined,
        customLabels: undefined,
        scriptPackageLabels: undefined,
        scriptHighlights: undefined,
        otherNotes: undefined,
        firstCityPrices: undefined,
        newFirstCityPrices: undefined,
        secondCityPrices: undefined,
        thirdCityPrices: undefined,
        fourthCityPrices: undefined,
        fifthCityPrices: undefined,
        applyWay: undefined,
        preOrderCarNum: undefined,
        firstCityOrderPrices: undefined,
        newFirstCityOrderPrices: undefined,
        secondCityOrderPrices: undefined,
        thirdCityOrderPrices: undefined,
        fourthCityOrderPrices: undefined,
        fifthCityOrderPrices: undefined,
        quickPlayedPrices: undefined,
        isHandselScript: undefined,
        openApplyTime: undefined,
        expectedShippingMissionDate: undefined,
        playedElectronicInfo: undefined,
        isMultipleEndings: undefined,
        isApply: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.scriptId)
      this.names = this.selectedRows.map(item => item.scriptName)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const scriptIds = row.scriptId || this.ids
      const scriptNames = row.scriptName || this.names
      this.$confirm({
        title: '确认删除 ' + scriptNames + ' 剧本?',
        // content: '当前选中编号为' + scriptIds + '的数据',
        onOk () {
          return delScript(scriptIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('played/script/export', {
            ...that.queryParam
          }, `script_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onClickNewScript ({ key }, scriptId) {
      this.scriptId = scriptId
      if (key === '1') {
        this.newProductSubscriptionsModal = true
      } else {
        this.noticeSubscriptions(key)
      }
    },
    noticeSubscriptions (key) {
      if (key === '1') {
        if (this.strValue1 == null) {
          this.$message.warning('请输入新品介绍')
          return
        } else if (this.strValue1.length > 20) {
          this.$message.warning('新品介绍字数不能超过20个字')
          return
        }
      }
      const that = this
      this.$confirm({
        title: '是否确认发送?',
        content: '此操作将发送给所有订阅新剧本的' + (key === '1' ? '玩家' : '店家'),
        onOk () {
          const data = {
            scriptId: that.scriptId,
            subsType: 1,
            loginType: key === '1' ? 'WX_MINI_PLAYED_USER' : 'WX_MINI_PLAYED_SHOP',
            strValue1: that.strValue1
          }
          sendScriptLaunch(data).then(() => {
            that.$message.success(
              '发送成功',
              3
            )
            that.closeModal()
          })
        },
        onCancel () {}
      })
    },
    generateShopScript (record) {
      if (record == null || record.scriptId == null) {
        return
      }
      generatePlayedScriptById(record.scriptId).then(res => {
        if (res.success) {
          this.$message.success(
            '生成店铺剧本成功',
            3
          )
        }
      })
    },

    // 关闭模态框
    closeModal () {
      this.newProductSubscriptionsModal = false
      this.strValue1 = null
      this.scriptId = null
    }
  }
}
</script>
<style scoped>
.new-product-subscriptions .ant-modal-body .ant-form-item {
  margin-bottom: 0;
}
.new-product-subscriptions .ant-modal-body .ant-form-item-label {
  line-height: 18px;
}
</style>
